import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { getGalleries, adminCreateGallery, adminDeleteGallery } from "../lib/api";
import { Toolbar, Modal, Field, Card, inputCls } from "./AdminLayout";
import { IconBtn } from "./ArticlesAdmin";
import { Trash2, Camera } from "lucide-react";

const empty = { title: "", photographer: "News Staff", cover: "", photosText: "" };

export default function GalleriesAdmin() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [busy, setBusy] = useState(false);

  const load = () => getGalleries().then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) return toast.error("Title is required.");
    const photos = form.photosText.split("\n").map((l) => l.trim()).filter(Boolean).map((line) => {
      const [url, ...cap] = line.split("|");
      return { url: url.trim(), caption: cap.join("|").trim() };
    });
    if (!photos.length) return toast.error("Add at least one photo URL.");
    setBusy(true);
    try {
      await adminCreateGallery({ title: form.title, photographer: form.photographer, cover: form.cover || photos[0].url, photos });
      toast.success("Gallery published."); setOpen(false); setForm(empty); load();
    } catch { toast.error("Could not save gallery."); }
    finally { setBusy(false); }
  };

  const remove = async (g) => {
    if (!window.confirm(`Delete "${g.title}"?`)) return;
    await adminDeleteGallery(g.id); toast.success("Gallery deleted."); load();
  };

  return (
    <div>
      <Toolbar title="Photo Galleries" subtitle="Publish photo essays and event galleries" onAdd={() => { setForm(empty); setOpen(true); }} addLabel="New Gallery" />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((g) => (
          <Card key={g.id} data-testid={`admin-gallery-${g.id}`} className="overflow-hidden">
            <div className="relative h-36">
              <img src={g.cover} alt={g.title} className="h-full w-full object-cover" />
              <span className="absolute left-2 top-2 flex items-center gap-1 rounded-full bg-black/55 px-2 py-0.5 text-[10px] text-white"><Camera size={10} /> {g.photos?.length || 0}</span>
            </div>
            <div className="flex items-center justify-between p-3">
              <div>
                <p className="font-semibold text-[var(--navy)] line-clamp-1">{g.title}</p>
                <p className="text-xs text-slate-500">by {g.photographer}</p>
              </div>
              <IconBtn onClick={() => remove(g)} danger testid={`delete-gallery-${g.id}`}><Trash2 size={15} /></IconBtn>
            </div>
          </Card>
        ))}
      </div>

      {open && (
        <Modal title="New Gallery" onClose={() => setOpen(false)} onSubmit={submit} busy={busy} submitLabel="Publish Gallery">
          <Field label="Gallery title"><input data-testid="gal-title" value={form.title} onChange={set("title")} className={inputCls} /></Field>
          <Field label="Photographer"><input data-testid="gal-photographer" value={form.photographer} onChange={set("photographer")} className={inputCls} /></Field>
          <Field label="Cover image URL (optional — first photo used if blank)"><input value={form.cover} onChange={set("cover")} className={inputCls} /></Field>
          <Field label="Photos — one per line as:  image-url | caption"><textarea data-testid="gal-photos" value={form.photosText} onChange={set("photosText")} rows={6} className={inputCls} placeholder="https://…/photo1.jpg | Pirates celebrate the win" /></Field>
        </Modal>
      )}
    </div>
  );
}
